import debounce from 'lodash/debounce'
import { AlignTypes, BaseFontProps, CommonProps, WebHeadlineTypes } from '../../styles/types'

type TextProps = {
    content: string
    textStyle?: BaseFontProps
    onPress?: () => void
    href?: string
    skipDebounce?: boolean
    // webHeadlineType is web only
    webHeadlineType?: WebHeadlineTypes
}

export type FloatingTextProps = CommonProps & {
    numberOfLines?: number
    textObjects: TextProps[]
    textAlign?: AlignTypes
    backgroundColor?: string
    lineHeight?: string | string[]
}

export const onPress = (skipDebounce?: boolean, onPress?: () => void): (() => void) | undefined => {
    if (skipDebounce && onPress) {
        return onPress
    } else if (onPress) {
        return debounce(onPress, 200, {
            leading: true,
            trailing: false,
        })
    }
    return undefined
}

export const defaultTextStyle = {
    fontSize: 16,
    fontWeight: 'normal',
}
